/** Dashboard widget: total value across the user's portfolios. */

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { apiClient } from "@/api/client";
import type { Portfolio } from "@/types";
import WidgetCard from "./WidgetCard";

export default function PortfolioValueWidget(): React.ReactElement {
  const [portfolios, setPortfolios] = useState<Portfolio[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    apiClient
      .get<Portfolio[]>("/portfolios")
      .then(({ data }) => setPortfolios(data))
      .catch(() => setError("Unable to load portfolios"));
  }, []);

  const portfolioList = Array.isArray(portfolios) ? portfolios : [];
  const totalValue = portfolioList.reduce((sum, p) => {
    const positions = Array.isArray(p.positions) ? p.positions : [];
    const positionsValue = positions.reduce(
      (s, pos) => s + Number(pos.quantity) * Number(pos.average_entry_price),
      0
    );
    return sum + positionsValue + Number(p.cash_balance);
  }, 0);

  return (
    <WidgetCard title="Portfolio value" isLoading={portfolios === null && !error} error={error}>
      <p className="font-mono text-2xl text-mist-100">${totalValue.toLocaleString()}</p>
      <p className="text-xs text-mist-400">
        Across {portfolioList.length} portfolio{portfolioList.length === 1 ? "" : "s"}
      </p>
      <Link to="/portfolio" className="text-xs text-signal-teal hover:underline">
        View portfolio →
      </Link>
    </WidgetCard>
  );
}
